import { useCallback } from '@web-stories-wp/react';
import { useSnackbar } from '@web-stories-wp/design-system';

export default function useLinearLightErrorNotice(effectName = 'Linear Light') {
  const { showSnackbar } = useSnackbar();
  return useCallback(
    () =>
      showSnackbar?.({
        message: `Unable to render ${effectName}. Check the layer image or font and try again.`,
        dismissable: true,
      }),
    [showSnackbar, effectName]
  );
}
